import type { IButtonMenu, IDomEditor } from "@wangeditor/editor";
import emitter from "./eventBus";
import { DomEditor } from "@wangeditor/editor";

// 引入app菜单
class MyButtonMenu implements IButtonMenu {
  title: string;
  tag: string;
  iconSvg: string;
  constructor() {
    this.title = "引入app"; // 自定义菜单标题
    this.iconSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M2 2h9v9H2zm2 2v5h5V4zm13.5 0a2.5 2.5 0 1 0 0 5a2.5 2.5 0 0 0 0-5M13 6.5a4.5 4.5 0 1 1 9 0a4.5 4.5 0 0 1-9 0M2 13h9v9H2zm2 2v5h5v-5zm9-2h9v9h-9zm2 2v5h5v-5z"/></svg>'; // 可选
    this.tag = "button";
  }

  getValue(editor: IDomEditor): string | boolean {
    return "";
  }

  isActive(editor: IDomEditor): boolean {
    return false;
  }

  isDisabled(editor: IDomEditor): boolean {
    return false;
  }

  exec(editor: IDomEditor, value: string | boolean) {
    console.log("editor", editor);
    emitter.emit("openDialog");
  }
}

export const menu1Conf = {
  key: "menu-self", // 定义 menu key ：要保证唯一、不重复（重要）
  factory() {
    return new MyButtonMenu(); // 把 `YourMenuClass` 替换为你菜单的 class
  }
};
